import { render } from "./Infografis.vue?vue&type=template&id=07627b2f"
import script from "./Infografis.vue?vue&type=script&lang=js"
export * from "./Infografis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__